import { Button, Empty } from 'antd'
import { LeadTimeLineEmptyMessageIcon } from 'components/icons'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

const VoiceEmptyState: FC<{ title?: string }> = ({ title }) => {
 const navigate = useNavigate()
 return (
  <div className="no-data-empty-compo">
   <Empty
    image={
     <span className="no-data-image">
      <LeadTimeLineEmptyMessageIcon />
     </span>
    }
    description={
     <span className="no-data-heading">
      {title ??
       'No call logs yet. Integrate your Twilio account to enable voice calling.'}
     </span>
    }
   >
    <Button
     shape="round"
     type="primary"
     className="mt-2"
     onClick={() => navigate('/admin/integration')}
    >
     Integrate
    </Button>
   </Empty>
  </div>
 )
}

export default VoiceEmptyState
